<template>

  <b-nav small tabs class="pageTabs" v-if="!presentationMode" style="position: relative">

    <b-nav-item v-if="isLoginUserPageItemReadable" :active="current=='intro'" title="기기에 대한 설정을 합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id } }">
      기본설정
    </b-nav-item>

    <b-nav-item v-if="isLoginUserPageItemWritable" :active="current=='config'" title="실제 기기 설정을 합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'config'}  }">
      기기설정
    </b-nav-item>

    <b-nav-item v-if="isLoginUserPageItemReadable" :active="current=='sensors'" title="센서를 설정합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'sensors'} }">
      센서설정
    </b-nav-item >

    <b-nav-item v-if="isLoginUserPageItemWritable" :active="current=='serial'" title="컴퓨터에 연결된 기기와 시리얼통신을 합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'serial'}  }">
      시리얼통신
    </b-nav-item>

    <b-nav-item v-if="isLoginUserPageUser || isLoginUserAdmin" :active="current=='auth'" title="데이터 업로드시 사용하는 접속 코드를 관리합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'auth'} }">
      접속코드
    </b-nav-item>

    <!--b-nav-item v-if="isLoginUserPageUser || isLoginUserAdmin" :active="current=='attributes'" title="기기에서 가져갈 수 있는 속성 값을 설정합니다." :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'attributes'} }">
      속성
    </b-nav-item-->

    <b-nav-item-dropdown v-if="isLoginUserPageItemWritable" id="my-nav-dropdown" :text="navDropdownName" :toggle-class="(navDropdownActive)? 'active': 'nav-link'" menu-class="fontSizeDot9">
      <b-dropdown-item v-if="isLoginUserPageUser || isLoginUserAdmin" :disabled="current=='attributes'" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'attributes'} }">속성</b-dropdown-item>
      <b-dropdown-item v-if="isLoginUserPageUser || isLoginUserAdmin" :disabled="current=='upload'" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'upload'} }">테스트</b-dropdown-item>
      <b-dropdown-item :disabled="current=='log'" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'log'} }">로그목록</b-dropdown-item>
      <b-dropdown-item :disabled="current=='report'" :to="{ name: 'tinkDevice', params: { did: pageDevice.id }, query: { mode: 'report'} }">보고서</b-dropdown-item>
    </b-nav-item-dropdown>

    <div class="buttonBox mt-1">
      <slot></slot>

      <b-button v-if="!isLoginUserPageUser && !isIdLoginUserFriend(this.pageUser.id)" variant="secondary" size="sm" class="tabButton mr-2" @click="addFriend(pageUser)">
        친구 &plus;
      </b-button>
      <span v-else-if="!isLoginUserPageUser" class="m-2 font-weight-bold tabText">
        <span v-if="isIdPageUserFriend(loginUser.id)">
          서로 친구
        </span>
        <span v-else>
          내 친구
        </span>
      </span>
      <span v-else class="m-2 font-weight-bold tabText">
        나
      </span>
      <b-button v-if="!isLoginUserPageUser" @click="addBookmarkPageDevice" variant="secondary" size="sm" class="tabButton mr-2" v-b-tooltip.hover.left title="북마크에 추가하기">
        북마크 &plus;
      </b-button>

    </div>
  </b-nav>
</template>
<script>
import uiUtil from "@/mixins/util.js"
import user from "@/mixins/user.js"
export default {
  name: "deviceTabs",
  mixins: [uiUtil, user],
  props: {
    pageDevice: {
      type: Object,
      default: null
    },
    pageUser: {
      type: Object,
      default: null
    },
    current: {
      type: String,
      default: ""
    },
  },
  computed: {
    navDropdownName: function() {
      if(this.current == "log") return "로그목록";
      else if(this.current == "report") return "보고서";
      else if(this.current == "upload") return "테스트";
      else if(this.current == "attributes") return "속성";
      else return "기타";
    },
    navDropdownActive: function() {
      if(this.current == "log" || this.current == "report" || this.current == "upload" || this.current == "attributes") return true;
      else return false;
    }
  },
  methods: {
    addBookmarkPageDevice: function() {
      this.addBookmark({
        "type": 20,
        "id": this.pageDevice.id,
        "name": this.pageDevice.name,
        "mode": this.current,
        "uid": this.pageUser.id,
        "uName": this.pageUser.displayName,
      });
    }
  }
}
</script>
